import { createStyles } from 'antd-style';
export var useStyles = createStyles(function (_ref) {
  var token = _ref.token;
  return {
    menu: {
      '& .ant-dropdown-menu-title-content': {
        display: 'flex',
        justifyContent: 'space-between'
      }
    },
    languageSelector: {
      color: '#969898',
      '&:hover': {
        color: token.colorPrimary
      }
    }
  };
});